// Query key factory for patient-related queries

import { PatientTableFilters } from "../../api-client";

const scopes = {
  patient: "patient",
  patientMinimal: "patientMinimal",
  patientByRxId: "patientByRxId",
  allPatients: "allPatients",
  allPatientsTable: "allPatientsTable",
  archivedPatients: "archivedPatients",
  rxStats: "rxStats",
  patientStats: "patientStats",
  patientRxSeries: "patientRxSeries",
  patientWaitlistStats: "patientWaitlistStats",
};

export const patientKeys = {
  patient: {
    scope: scopes.patient,
    all: () => [scopes.patient] as const,
    detail: (id: number) => [scopes.patient, { id }] as const,
    rxs: (patientId: number, includeDeleted: boolean) =>
      [scopes.patient, "rxs", { patientId, includeDeleted }] as const,
  },
  patientMinimal: {
    scope: scopes.patientMinimal,
    all: () => [scopes.patientMinimal] as const,
    detail: (id: number) => [scopes.patientMinimal, { id }] as const,
    batch: (ids: number[]) =>
      [scopes.patientMinimal, "batch", [...ids].sort((a, b) => a - b)] as const,
  },
  patientByRxId: {
    scope: scopes.patientByRxId,
    all: () => [scopes.patientByRxId] as const,
    detail: (rxId: string) => [scopes.patientByRxId, { rxId }] as const,
  },
  allPatients: {
    scope: scopes.allPatients,
    all: () => [scopes.allPatients] as const,
  },
  allPatientsTable: {
    scope: scopes.allPatientsTable,
    all: () => [scopes.allPatientsTable] as const,
    filtered: (filters: PatientTableFilters) => [scopes.allPatientsTable, filters] as const,
  },
  archivedPatients: {
    scope: scopes.archivedPatients,
    all: () => [scopes.archivedPatients] as const,
    detail: (page: number, limit: number, search?: string) =>
      [scopes.archivedPatients, { page, limit, search }] as const,
  },
  rxStats: {
    scope: scopes.rxStats,
    all: () => [scopes.rxStats] as const,
  },
  patientStats: {
    scope: scopes.patientStats,
    all: () => [scopes.patientStats] as const,
  },
  patientRxSeries: {
    scope: scopes.patientRxSeries,
    all: () => [scopes.patientRxSeries] as const,
    detail: (patientId: number) => [scopes.patientRxSeries, { patientId }] as const,
  },
  patientWaitlistStats: {
    scope: scopes.patientWaitlistStats,
    all: () => [scopes.patientWaitlistStats] as const,
    detail: (patientId: number) => [scopes.patientWaitlistStats, { patientId }] as const,
  },
};
